(function () {
  'use strict';

  var DURATION_EXIT  = 260; /* ms bis Navigation */
  var DURATION_ENTRY = 440; /* ms Overlay slide-out */

  var overlay    = null;
  var navigating = false;
  var lastTapX   = window.innerWidth  / 2;
  var lastTapY   = window.innerHeight / 2;

  /* Track exact tap/click position before anything else fires */
  document.addEventListener('click', function (e) {
    lastTapX = e.clientX;
    lastTapY = e.clientY;
  }, true);

  /* ── Nav level helper ────────────────────────── */
  function navLevel(path) {
    path = path || window.location.pathname;
    if (path === '/' || path === '') return 0;
    if (path.startsWith('/collections')) return 1;
    if (path.startsWith('/products'))   return 2;
    if (path === '/cart')               return 3;
    if (path.startsWith('/account'))    return 4;
    return 1;
  }

  /* ── Overlay bauen ───────────────────────────── */
  function buildOverlay() {
    overlay = document.createElement('div');
    overlay.className = 'pgtrans-overlay';
    overlay.style.transition = 'none';
    overlay.style.transform  = 'translateX(0)'; /* startet abgedeckt */
    document.body.appendChild(overlay);
  }

  /* ── Seite zeigen: Overlay fährt raus ────────── */
  function enterPage() {
    var dir = sessionStorage.getItem('pgtrans');
    sessionStorage.removeItem('pgtrans');

    if (!dir) {
      /* Direktaufruf: Overlay gar nicht zeigen */
      overlay.style.transform = 'translateX(105%)';
      return;
    }

    var backward = dir === 'back';
    document.documentElement.classList.add('pgtrans-enter');

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        overlay.style.transition = 'transform ' + DURATION_ENTRY + 'ms cubic-bezier(0.87,0,0.13,1)';
        overlay.style.transform  = backward ? 'translateX(-105%)' : 'translateX(105%)';
        setTimeout(function () {
          document.documentElement.classList.remove('pgtrans-enter');
          overlay.style.transition = 'none';
        }, DURATION_ENTRY + 60);
      });
    });
  }

  /* ── Seite verlassen: Overlay fährt rein ─────── */
  function exitPage(href) {
    if (navigating) return;
    navigating = true;

    try { window.dispatchEvent(new CustomEvent('fifteen-page-exit', { detail: { x: lastTapX, y: lastTapY } })); } catch (ignored) {}

    var going    = navLevel(href);
    var current  = navLevel(window.location.pathname);
    var backward = going < current;

    sessionStorage.setItem('pgtrans', backward ? 'back' : 'fwd');

    /* Overlay starts offscreen in the direction we're coming FROM */
    overlay.style.transition = 'none';
    overlay.style.transform  = backward ? 'translateX(-105%)' : 'translateX(105%)';

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        overlay.style.transition = 'transform ' + DURATION_EXIT + 'ms cubic-bezier(0.87,0,0.13,1)';
        overlay.style.transform  = 'translateX(0)';
      });
    });

    setTimeout(function () { window.location.href = href; }, DURATION_EXIT - 30);
  }

  /* ── Links abfangen ──────────────────────────── */
  function shouldIntercept(el) {
    var href = el.getAttribute('href');
    if (!href) return false;

    /* Externe, Anchor, Special-Links */
    if (href.charAt(0) === '#') return false;
    if (/^(https?:|\/\/|mailto:|tel:|javascript:)/i.test(href)) return false;
    if (el.target && el.target !== '_self') return false;
    if (el.hasAttribute('download')) return false;

    /* Shopify-interne Sonderlinks (Cart, AJAX) */
    if (el.closest('cart-drawer, cart-notification, .cart-drawer, [data-ajax]')) return false;
    if (href === '/cart') return false;          /* let Dawn cart-drawer handle this */
    if (href.startsWith('/cart/')) return false;
    if (href.includes('checkout')) return false;

    /* Don't re-navigate to current page (fixes home button on homepage) */
    if (href === window.location.pathname) return false;

    return true;
  }

  document.addEventListener('click', function (e) {
    var el = e.target.closest('a[href]');
    if (!el || !shouldIntercept(el)) return;

    e.preventDefault();
    exitPage(el.getAttribute('href'));
  }, true); /* capture phase — vor Shopify-Handlern */

  /* ── Boot ─────────────────────────────────────── */
  function init() {
    buildOverlay();
    enterPage();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* Ship bar: show briefly, then collapse */
(function() {
  setTimeout(function() {
    var bar = document.querySelector('.ship-bar');
    if (bar) bar.classList.add('collapsed');
    document.body.classList.add('ship-gone');
  }, 3200);
})();
